import { getGaugeStyle, getValueIndex } from "../soil/colors/olsen"
import { isNumber } from "../utils/utils"
import { convertStyle } from "./react"

interface Props {
    value: number
    index: boolean
    attr: string
}

export function AnalysisValueGauge({ value, index, attr }: Props) {

    if (!isNumber(value)) {
        return null
    }

    const style = convertStyle(getGaugeStyle(value, attr))

    value = index
        ? getValueIndex(value, attr)
        : value

    return <>

        <div className="gauge-container">
            <div></div>
            <div></div>
            <div style={style}>
            </div>
            <div>
                <span>{value}</span>
            </div>
        </div>

    </>
}
